import * as Types from '../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type CustomerSearchHookQueryVariables = Types.Exact<{
  input: Types.CustomersSearchArgsInput;
}>;


export type CustomerSearchHookQuery = { __typename?: 'QueryModel', customers: { __typename?: 'CustomersQueryModel2', search: { __typename?: 'ConnectionOfCustomer', token?: string | null, records: Array<{ __typename?: 'Customer', customerId: number, name: string, number?: string | null, status: Types.CustomerStatus, createCustomerRequestId: any, badDebtWriteOffs: Array<{ __typename?: 'BadDebtWriteOff', date: string, amount: number }> }> } } };


export const CustomerSearchHookDocument = gql`
    query CustomerSearchHook($input: CustomersSearchArgsInput!) {
  customers {
    search(input: $input) {
      token
      records {
        customerId
        name
        number
        status
        createCustomerRequestId
        badDebtWriteOffs {
          date
          amount
        }
      }
    }
  }
}
    `;

/**
 * __useCustomerSearchHookQuery__
 *
 * To run a query within a React component, call `useCustomerSearchHookQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerSearchHookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerSearchHookQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerSearchHookQuery(baseOptions: Apollo.QueryHookOptions<CustomerSearchHookQuery, CustomerSearchHookQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerSearchHookQuery, CustomerSearchHookQueryVariables>(CustomerSearchHookDocument, options);
      }
export function useCustomerSearchHookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerSearchHookQuery, CustomerSearchHookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerSearchHookQuery, CustomerSearchHookQueryVariables>(CustomerSearchHookDocument, options);
        }
export type CustomerSearchHookQueryHookResult = ReturnType<typeof useCustomerSearchHookQuery>;
export type CustomerSearchHookLazyQueryHookResult = ReturnType<typeof useCustomerSearchHookLazyQuery>;
export type CustomerSearchHookQueryResult = Apollo.QueryResult<CustomerSearchHookQuery, CustomerSearchHookQueryVariables>;